// Package Imports
import { useTranslate } from '@refinedev/core';
import { Checkbox, Col, Form, Input, Row } from 'antd';
import regex from 'core/constants/Regex';

const RuleConfiguration = ({ outputValue, type }) => {
  const t = useTranslate();

  return (
    <div>
      {outputValue?.length > 0 ? (
        <Form.List name="rule_output_config">
          {(subFields, fieldAddRemove, { errors }) => (
            <div>
              {subFields?.map((subField) => (
                <Row
                  key={subField.key}
                  gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}
                  className="my-4 items-center"
                >
                  <Col xs={24} sm={24} lg={9}>
                    <div className="floating-disabled relative custom-dropdown">
                      <label className="floating-label">
                        {t('rules.outputName')}
                        <span className="a8-error">*</span>
                      </label>
                      <Form.Item
                        rules={[
                          {
                            pattern: regex.noTags,
                            message: 'Input must not contain HTML or XML tags.',
                          },
                        ]}
                        name={[subField.name, 'output']}
                      >
                        <Input
                          className="py-3 font-semibold"
                          placeholder={t('rules.messages.ruleName')}
                          disabled={type === 'Show'}
                        />
                      </Form.Item>
                    </div>
                  </Col>
                  <Col className="text-center mt-4" xs={24} sm={24} lg={6}>
                    <div className="flex justify-center">
                      <Form.Item name={[subField.name, 'isSelected']}>
                        <Checkbox disabled={type === 'Show'} />
                      </Form.Item>
                      <label className="ml-4 mt-2 font-semibold">
                        {t('rules.ruleConfigCheckboxLabel')}
                      </label>
                    </div>
                  </Col>
                  <Col xs={24} sm={24} lg={9}>
                    <div className="relative custom-border">
                      <label className="floating-label">Value</label>
                      <Form.Item
                        rules={[
                          {
                            pattern: regex.noTags,
                            message: 'Input must not contain HTML or XML tags.',
                          },
                        ]}
                        name={[subField.name, 'output']}
                      >
                        <Input
                          disabled={type === 'Show'}
                          placeholder="Enter Value"
                          className="py-3"
                        />
                      </Form.Item>
                    </div>
                  </Col>
                </Row>
              ))}
              <div className="a8-error">
                <Form.ErrorList errors={errors} />
              </div>
            </div>
          )}
        </Form.List>
      ) : null}
    </div>
  );
};

export default RuleConfiguration;
